import { IMortgagePrograms } from '../../types/promosPage/mortgagePrograms';
import { IApplicationState } from '../../types/redux';

export const selectMortgagePrograms = (state: IApplicationState): IMortgagePrograms[] => {
  return state.promosPage.mortgagePrograms;
};
